import { LitElement, html, css } from '~/lib/bn-lit-element';

class BnProgressBar extends LitElement {
  constructor() {
    super();
    this.progress = 0;
  }

  static get properties() {
    return {
      progress: { type: Number },
    };
  }

  static get styles() {
    return [css`
      :host {
        display: block;
      }
      #loading-bar {
        position: fixed;
        top: 0px;
        width: 100%;
        background-color: var(--blue-50);
        z-index: 1;
      }
      #loading-bar .progress {
        transition: height .5s ease, width .5s ease;
        height: 2px;
        width: 0%;
      }
    `];
  }

  render() {
    return html`
      <div id="loading-bar">
        <div class="progress"></div>
      </div>
    `;
  }

  set progress(val) {
    const old = this._progress;
    this._progress = val || 0;
    this._progressChange();
    this.requestUpdate('progress', old);
  }

  get progress() {
    return this._progress;
  }

  _progressChange() {
    const progressBar = this.shadowRoot.querySelector('#loading-bar .progress');
    if (!progressBar) {
      return;
    }
    if (this.progress === 100) {
      progressBar.style.backgroundColor = 'var(--green-20)';
      progressBar.style.width = '100%';
      this.hideProgress = setTimeout(() => progressBar.style.height = '0', 500);
    } else {
      this.hideProgress && clearTimeout(this.hideProgress);
      progressBar.style.backgroundColor = 'var(--blue-60)';
      progressBar.style.height = '3px';
      progressBar.style.width = `${Math.max(this.progress, 10)}%`;
    }
  }
}

window.customElements.define('bn-progressbar', BnProgressBar);
